const React = require('react');

const Pin = () => (
  <svg className="button-icon" viewBox="0 0 16 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.8">
      <path
        className="button-icon__path"
        d="M7.999,0.2 C10.9840991,0.2 13.404,2.61990093 13.404,5.605 C13.404,8.17833231 11.7432013,11.3695362 8.45565155,15.2269379 L8.45565155,15.2269379 L7.999,15.7627438 L7.54234845,15.2269379 C4.25479868,11.3695362 2.594,8.17833231 2.594,5.605 C2.594,2.61990093 5.01390093,0.2 7.999,0.2 Z M8,3.2 C6.6745166,3.2 5.6,4.2745166 5.6,5.6 C5.6,6.9254834 6.6745166,8 8,8 C9.3254834,8 10.4,6.9254834 10.4,5.6 C10.4,4.2745166 9.3254834,3.2 8,3.2 Z"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

module.exports = Pin;
